import {
  chainSettings,
  type ChainType,
} from "@/constants/chain-specific/chains";
import {
  GeckoApi,
  type TokensInfoDetailData,
  type ErrorsObject,
  type HttpResponse,
  type TokensDetailData,
} from "@/lib/gecko-api";
import { imageExists } from "@/util/img/imageExists";

const api = new GeckoApi();

export async function getTokenInfo(chainId: ChainType, tokenAddress: string) {
  const network = chainSettings[chainId].tokenApiSetting.network;

  const response: HttpResponse<TokensInfoDetailData, ErrorsObject> =
    await api.networks.tokensInfoDetail(network, tokenAddress);

  if (response.ok) {
    const attr = response.data?.data?.attributes;
    const gt_score = Number(attr?.gt_score) || 0;
    let logo = attr?.image_url ? attr?.image_url : undefined;
    if (logo === undefined || logo === "missing.png" ) {
      if (chainId === 109) {
		const shibCdn = `https://github.com/shibaone/shibarium-images/blob/main/assets/images/shibarium/${tokenAddress.toLowerCase()}.png?raw=true`
		const exists =  await imageExists(shibCdn)
        if ( exists ) logo = `https://github.com/shibaone/shibarium-images/blob/main/assets/images/shibarium/${tokenAddress.toLowerCase()}.png?raw=true`;
      }
    }
    const website = attr?.websites ? attr?.websites[0] : undefined;
    const telegram = attr?.telegram_handle
      ? `https://t.me/${attr?.telegram_handle}`
      : undefined;
    const twitter_handle = attr?.twitter_handle
      ? `https://x.com/${attr?.twitter_handle}`
      : undefined;

    return {
      name: attr?.name,
      symbol: attr?.symbol,
      decimals: attr?.decimals,
      gt_score: gt_score,
      logo: logo,
      website: website,
      telegram: telegram,
      twitter_handle: twitter_handle,
    };
  }
}
